import axios from 'axios';

export const API_URL = 'https://cambridgeschooljjr.com/admin/public';

const API = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' }
});

export const UPLOADS_URL = `${API_URL}/uploads`;

export default API;
